import React from "react";
import ReactDOM from "react-dom/client";
import App from "@/App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "mobx-react";
import { rootStore } from "@/mobx/store";
import reportWebVitals from "./reportWebVitals";
import "chart.js/auto";
import "./utils/pdfConfig";

//styled-component theme
import theme from "./design/defaultTheme";
import { ThemeProvider } from "styled-components";

// v1.0.0
// css
import "bootstrap/dist/css/bootstrap.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "react-notifications-component/dist/theme.css";
import "react-datetime/css/react-datetime.css";
import "./assets/css/default/app.min.css";

import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "react-18-image-lightbox/style.css";
// ========================================

// extension
import "./helper/extension";
import "moment/locale/ko";
import { GoogleOAuthProvider } from "@react-oauth/google";
// ========================================

// Global error handler
window.addEventListener("error", (event) => {
  console.error("Global error:", event.error);
});

window.addEventListener("unhandledrejection", (event) => {
  console.error("Unhandled promise rejection:", event.reason);
});

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then(function (registration) {
      console.log("Registration successful, scope is:", registration.scope);
    })
    .catch(function (err) {
      console.log("Service worker registration failed, error:", err);
    });
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Failed to find the root element");
}

const root = ReactDOM.createRoot(rootElement);

try {
  root.render(
    <GoogleOAuthProvider
      clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ""}
    >
      <BrowserRouter>
        <Provider rootStore={rootStore}>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </Provider>
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
} catch (error) {
  console.error("Failed to render app:", error);
}

// Firebase messaging already owns the root service-worker scope above.
// The custom webpack build does not emit CRA's /service-worker.js, so do not
// register the legacy CRA worker here.
if (process.env.NODE_ENV === "production") {
  // Production에서만 콘솔 로그 제거
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
